import React, { useEffect, useState } from "react";
import HtmlHead from "../components/html-head/HtmlHead";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import RightMenu from "./components/RightMenu";
import { useDispatch, useSelector } from "react-redux";
import { setIsOpenRightMenu } from "../store/reducers/menuReducer";
import OrderModal from "./components/OrderModal";
import ModalComponent from "./components/ModalComponent";
import Header from "../components/layaut/Header";
import Marquee from "../components/marquee/Marquee";
import useWindowSize from "../components/hooks/useWindowSize";
import { resolveApiAssetUrl } from "../helpers/services/apiSrevice";

const SuperDetkaView = ({ courseData, getCourseById }) => {

    const dispatch = useDispatch();
    const windowSize = useWindowSize();
    const navigate = useNavigate();
    const { user } = useSelector(state => state.user);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [courseInfo, setCourseInfo] = useState(null);
    const title = courseData.title || "";
    const description = "";
    const gifSrc = resolveApiAssetUrl(courseData.gifFile || courseData.gifFilePath) || "/gif/super-detka.gif";
    const sideImageSrc = resolveApiAssetUrl(courseData.bottomImage || courseData.bottomImagePath) || "/images/phone.svg";

    const splitTitle = (title) => {
        if (!title) return "";
        const words = title.split(" ");
        return <div>
            <h2 className="title montserrat-alternates-bold mb-0" style={{ textTransform: "uppercase" }}>{words[0] || ""}</h2>
            <h3 className="sub-title montserrat-alternates-bold" style={{ textTransform: "lowercase" }}>{words[1] || ""}</h3>
        </div>
    }

    const getCourseEligibility = (eligibility) => {
        if (!eligibility) return "";
        const words = eligibility.split(" ");
        return <>
            {
                words.map((el, index) => {
                    return <p className="m-0" key={index}>{el}</p>
                })
            }
        </>
    }

    useEffect(() => {
        if (isModalOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isModalOpen]);

    function decodeHtmlEntities(html) {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    return <div className="super-detka-view">
        <HtmlHead title={title} description={description} />
        <OrderModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            courseData={courseData}
            getCourseById={getCourseById}
        />
        <ModalComponent isOpen={courseInfo ? true : false} onClose={() => setCourseInfo(null)}>
            {
                courseInfo && courseInfo.courseInfoContents && courseInfo.courseInfoContents.length ?
                    courseInfo.courseInfoContents.map((el, idx) => {
                        return <div key={idx} className={`${idx % 2 === 0 ? "bg-white" : "bg-light-green"} radius-20`}>
                            <div className="course-info-modal" dangerouslySetInnerHTML={{ __html: decodeHtmlEntities(el.textData) }}></div>
                        </div>
                    })
                    : null
            }
        </ModalComponent>
        <RightMenu>
            <div>
                {
                    courseData.courseInfos && courseData.courseInfos.length ?
                        courseData.courseInfos.map((item, index) => {
                            return <Link
                                to="#"
                                key={index}
                                className="link"
                                onClick={() => {
                                    if (item && item.courseInfoContents && item.courseInfoContents.length) {
                                        setCourseInfo(item);
                                    } else if (item.link) {
                                        window.open(item.link, "_blank")
                                    }
                                }}
                            >
                                {item.title}
                            </Link>
                        })
                        : null
                }
            </div>
        </RightMenu>

        <Header>
            <div className="w-100 d-flex">
                <div className="d-flex justify-content-center w-100 gap-3">
                    {
                        courseData.courseInfos && courseData.courseInfos.length ?
                            courseData.courseInfos.map((item, index) => {
                                return <Link
                                    to="#"
                                    key={index}
                                    className={`header-button text-nowrap ${item.isActive ? "active" : ""}`}
                                    onClick={() => {
                                        if (item && item.courseInfoContents && item.courseInfoContents.length) {
                                            setCourseInfo(item);
                                        } else if (item.link) {
                                            window.open(item.link, "_blank");
                                        }
                                    }}
                                >
                                    {item.title}
                                </Link>
                            })
                            : null
                    }
                </div>
            </div>
        </Header>

        <Container className="first-block">
            <Row>
                <Col sm={12}>
                    <div className="title-block">
                        {splitTitle(courseData.title)}
                        <div className="green-text mt-4 d-none d-md-block" dangerouslySetInnerHTML={{ __html: courseData.slogan }}></div>
                    </div>
                    {
                        courseData.subtitle ?
                            <div className="info-texts mt-4">
                                {getCourseEligibility(courseData.subtitle)}
                            </div>
                            : null
                    }
                </Col>
            </Row>
            <div className="super-detka-cat">
                <img src={gifSrc} alt={courseData.title || "course-gif"} />
            </div>
        </Container>
        <div className="green-text d-block d-md-none text-center" dangerouslySetInnerHTML={{ __html: courseData.slogan }}></div>
        <Container>
            <div className="price-block">
                <div className="price-button-block position-relative gap-4">
                    {
                        courseData.isBelongToUser ?
                            <button className="price-button radius-100" onClick={() => navigate(`/course-content/${courseData.id}`)}>
                                К КУРСУ
                            </button>
                            : <button className="price-button radius-100" onClick={() => setIsModalOpen(true)}>
                                {/* КУПИТЬ ЗА {courseData?.ongoingDiscount && courseData?.ongoingDiscount?.discountedPrice ? courseData?.ongoingDiscount?.discountedPrice : courseData.basePrice} */}
                                КУПИТЬ ЗА {courseData?.finalPrice}
                                {
                                    courseData?.ongoingDiscount ?
                                        <b className="discount">
                                            -{courseData?.ongoingDiscount?.discountPercentage}%
                                        </b>
                                        : null
                                }
                                {
                                    courseData?.ongoingDiscount ?
                                        <div className="old-price-block">
                                            <div className="old-price d-flex align-items-center">
                                                <b>{courseData?.basePrice}</b>
                                            </div>
                                        </div>
                                        : null
                                }
                            </button>
                    }

                </div>
            </div>
        </Container>

        <div>
            <div className="uneven-edge-block">
                <svg width="1440" height="90" viewBox="0 0 1440 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M344.52 26.4584L328.906 21.6816C280.198 6.78057 228.498 4.52681 178.678 15.1326L128.243 25.8695C115.406 28.6021 102.143 28.6375 89.292 25.9735L26.3649 12.928C3.21702 8.12926 -18.8226 24.9218 -20.3393 48.5131C-21.7803 70.9268 -3.98945 89.8981 18.4705 89.8981H1424.17C1450.38 89.8981 1470.99 67.516 1468.85 41.3987C1466.33 10.7862 1434.47 -8.28397 1406.3 3.96253L1347.94 29.3346C1330.35 36.9815 1310.78 38.8353 1292.07 34.6279L1194.22 12.6271C1154.25 3.63924 1112.74 4.03961 1072.95 13.7968L1053.46 18.5754C1022.86 26.0788 990.855 25.7272 960.427 17.5533C936.542 11.1372 911.621 9.52362 887.108 12.8059L803.523 23.9982C773.745 27.9855 743.537 27.4772 713.91 22.4901L679.995 16.7814C644.838 10.8635 608.908 11.2597 573.89 17.9512L488.59 34.2509C440.648 43.4121 391.195 40.7373 344.52 26.4584Z" fill="#222222" />
                </svg>
                <svg className="second" width="1440" height="90" viewBox="0 0 1440 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M344.52 26.4584L328.906 21.6816C280.198 6.78057 228.498 4.52681 178.678 15.1326L128.243 25.8695C115.406 28.6021 102.143 28.6375 89.292 25.9735L26.3649 12.928C3.21702 8.12926 -18.8226 24.9218 -20.3393 48.5131C-21.7803 70.9268 -3.98945 89.8981 18.4705 89.8981H1424.17C1450.38 89.8981 1470.99 67.516 1468.85 41.3987C1466.33 10.7862 1434.47 -8.28397 1406.3 3.96253L1347.94 29.3346C1330.35 36.9815 1310.78 38.8353 1292.07 34.6279L1194.22 12.6271C1154.25 3.63924 1112.74 4.03961 1072.95 13.7968L1053.46 18.5754C1022.86 26.0788 990.855 25.7272 960.427 17.5533C936.542 11.1372 911.621 9.52362 887.108 12.8059L803.523 23.9982C773.745 27.9855 743.537 27.4772 713.91 22.4901L679.995 16.7814C644.838 10.8635 608.908 11.2597 573.89 17.9512L488.59 34.2509C440.648 43.4121 391.195 40.7373 344.52 26.4584Z" fill="#222222" />
                </svg>
                <div className="layer" />
            </div>
        </div>

        <div className="bottom-block">
            <Container>
                <Row className="position-relative">
                    <Col md={6} className="d-block d-md-none">
                        <div className=" position-relative mt-4">
                            <div className="text">
                                <div dangerouslySetInnerHTML={{ __html: courseData.description }}></div>
                            </div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="image-block">
                            <img src={sideImageSrc} alt={courseData.title || "course-image"} />
                        </div>
                    </Col>
                    <Col md={6} className="d-none d-md-block">
                        <div className=" position-relative mt-4">
                            <div className="text">
                                <div dangerouslySetInnerHTML={{ __html: courseData.description }}></div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
        <Marquee
            content={windowSize.width > 1024 ? ["логопед-дефектолог", "наталья смагина", "логопед-дефектолог", "наталья смагина"] : ["логопед-дефектолог", "Наталья Смагина"]}
            blockClassName="dark-bg"
        />
    </div >
}

export default SuperDetkaView
